export default "__VITE_ASSET__BgqDhJuL__"